<div class="flex flex-column align-items-start gap-3 align-self-stretch pb-4 pt-4">
  <fieldset class="sps-fieldset form-data-container">
    <div class="flex flex-column gap-2 w-full">
      <label for="link-status">{{ i18n.i18nLng()['LINKSTATUS'] }}</label>
    </div>
    <div class="flex align-items-center gap-2">
      <p-toggleswitch [(ngModel)]="paymentPageLinkData.enabled"/>
      <span class="text-lg">{{ i18n.i18nLng()['ACTIVE'] }}</span>
    </div>
    <div class="flex flex-column gap-2 w-full">
      <label for="link-name">{{ i18n.i18nLng()['LINKNAME'] }}<sup class="sps-sup">*</sup></label>
      <input pInputText
             [pAutoFocus]="true"
             id="link-name"
             maxlength="70"
             [(ngModel)]="paymentPageLinkData.name"
             [required]="true"
             (ngModelChange)="dataChanged.emit()"
             [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
             [ngClass]="paymentPageLinkInvalidFlags.name ? 'ng-invalid ng-dirty' : null"
             [attr.aria-invalid]="paymentPageLinkInvalidFlags.name"
             [attr.aria-describedby]="paymentPageLinkInvalidFlags.name ? 'name-invalid-help' : null"
             pSize="large"/>
      @if (paymentPageLinkInvalidFlags.name) {
        <small style="line-height: 1.5rem" class="text-error" role="alert" id="name-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
      }
    </div>
    <div class="flex flex-column gap-2 w-full">
      <label for="purpose">{{ i18n.i18nLng()['PURPOSE'] }}<sup class="sps-sup">*</sup></label>
      <input pInputText
             id="purpose"
             maxLength="140"
             [(ngModel)]="paymentPageLinkData.purpose"
             [required]="true"
             (ngModelChange)="dataChanged.emit()"
             [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
             [ngClass]="paymentPageLinkInvalidFlags.purpose ? 'ng-invalid ng-dirty' : null"
             [attr.aria-invalid]="paymentPageLinkInvalidFlags.purpose"
             [attr.aria-describedby]="paymentPageLinkInvalidFlags.purpose ? 'purpose-invalid-help' : null"
             pSize="large"/>
      @if (paymentPageLinkInvalidFlags.purpose) {
        <small style="line-height: 1.5rem" class="text-error" role="alert" id="purpose-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
      }
    </div>
    <div class="flex flex-column gap-2 w-full">
      <label for="organisation">{{ i18n.i18nLng()['ORGANISATIONNAME'] }}<sup class="sps-sup">*</sup></label>
      <input pInputText
             id="organisation"
             maxlength="120"
             [(ngModel)]="paymentPageLinkData.organisationName"
             [required]="true"
             (input)="helper.allowOnlyChars($event, allowedOrganisationChars)"
             (ngModelChange)="dataChanged.emit()"
             [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
             [ngClass]="paymentPageLinkInvalidFlags.organisationName ? 'ng-invalid ng-dirty' : null"
             [attr.aria-invalid]="paymentPageLinkInvalidFlags.organisationName"
             [attr.aria-describedby]="paymentPageLinkInvalidFlags.organisationName ? 'organisation-invalid-help' : null"
             pSize="large"/>
      @if (paymentPageLinkInvalidFlags.organisationName) {
        <small style="line-height: 1.5rem" class="text-error" role="alert" id="organisation-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
      }
    </div>
    @if (paymentPageLinkData.type === 'DONATION') {
      <div class="flex align-items-center">
        <p-checkbox inputId="request-receipt-data" [(ngModel)]="paymentPageLinkData.requestDonationReceiptData" [binary]="true" size="large"/>
        <label for="request-receipt-data" class="ml-2 text-lg">{{ i18n.i18nLng()['REQUESTDONATIONRECEIPTDATA'] }}</label>
      </div>
    }
  </fieldset>
</div>
